declare global {
  interface Window {
    ym?: (...args: unknown[]) => void;
  }
}

export function trackMetrikaPageView(url: string, referer: string, hostname = window.location.hostname): boolean {
  if (hostname !== 'lk.flypix.online' || typeof window.ym !== 'function') return false;
  window.ym(113755510, 'hit', url, { referer, title: document.title });
  return true;
}
